import axios from 'axios'

function getParameter(data) {
    var parameter = '?'
    for (var item in data) {
        parameter = parameter + item + '=' + data[item] + '&'
    }
    parameter = parameter.substring(0, parameter.length - 1)
    return parameter
}

//企业动态类型
export function getNewsTypeApi() {
    return axios({
        url: `api/tabDynamic/getNewsType`,
        method: 'get'
    })
}
//首页企业动态列表
export function homePageGetNewsList() {
    return axios({
        url: `api/homePage/getNewsList`,
        method: 'get'
    })
}
//企业动态列表
export function getNewsListApi(data) {
    return axios({
        url: `api/tabDynamic/getNewsList${getParameter(data)}`,
        method: 'get'
    })
}
//企业动态详情
export function getNewsInfoApi(data) {
    return axios({
        url: `api/tabDynamic/getNewsInfo${getParameter(data)}`,
        method: 'get'
    })
}
//产品类型
export function getProductTypeApi() {
    return axios({
        url: `api/tabProduct/getProductType`,
        method: 'get'
    })
}
//产品列表
export function getProductListApi(data) {
    return axios({
        url: `api/tabProduct/getProductList${getParameter(data)}`,
        method: 'get'
    })
}
//产品详情
export function getProductInfoApi(data) {
    return axios({
        url: `api/tabProduct/getProductInfo${getParameter(data)}`,
        method: 'get'
    })
}

//解决方案类型
export function getPlanTypeApi() {
    return axios({
        url: `api/tabPlan/getPlanType`,
        method: 'get'
    })
}
//精彩案例
export function getProductList() {
    return axios({
        url: `api/homePage/getProductList`,
        method: 'get'
    })
}
//解决方案列表
export function getPlanListApi(data) {
    return axios({
        url: `api/tabPlan/getPlanList${getParameter(data)}`,
        method: 'get'
    })
}
//解决方案详情
export function getPlanInfoApi(data) {
    return axios({
        url: `api/tabPlan/getPlanInfo${getParameter(data)}`,
        method: 'get'
    })
}

//平台服务类型
export function getServiceTypeApi() {
    return axios({
        url: `api/tabService/getServiceType`,
        method: 'get'
    })
}
//平台服务详情
export function getServiceInfoApi(data) {
    return axios({
        url: `api/tabService/getServiceInfo${getParameter(data)}`,
        method: 'get'
    })
}



//下载中心
export function getFileDowloadApi(data) {
    return axios({
        url: `api/tabFileDowload/getFileDowload${getParameter(data)}`,
        method: 'get'
    })
}

//荣誉资质
/* export function getHonorInfoApi(pageNumber, pageSize) {
    return axios({
        url: `api/tabHonor/getHonorInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        method: 'get'
    })
} */
export function getHonorInfo(pageNumber, pageSize) {
    return axios({
        url: `api/tabHonor/getHonorInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        method: 'get'
    })
}
// 专利著作
export function getPatentInfo(pageNumber, pageSize) {
    return axios({
        url: `api/tabHonor/getPatentInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        method: 'get'
    })
}


//底部
export function getUnderInfoListApi() {
    return axios({
        url: `api/homePage/getUnderInfoList`,
        method: 'get'
    })
}

//合作伙伴
export function getPartnerAllListApi(data) {
    return axios({
        url: `api/homePage/getPartnerAllList${getParameter(data)}`,
        method: 'get'
    })
}

//联系我们
export function getContactInfoApi(data) {
    return axios({
        url: `api/tabContact/getContactInfo`,
        method: 'get'
    })
}

//公司简介
export function getCompanyInfoApi() {
    return axios({
        url: `api/tabCompany/getCompanyInfo`,
        method: 'get',
    })
}
//
export function getCompanyInfoApi111(data) {
    return axios({
        url: `api/tabProduct/getProductInfo${getParameter(data)}`,
        method: 'get',
    })
}

//需求提交
export function saveService(data) {
    return axios({
        url: `api/homePage/saveService`,
        data: data,
        method: 'post',
    })
}

export function sendCodeApi(data) {
    return axios({
        url: `api/webUser/sendCode`,
        data: data,
        method: 'post'
    })
}

export function loginApi(data) {
    return axios({
        url: `api/webUser/login`,
        data: data,
        method: 'post'
    })
}

export function registerApi(data) {
    return axios({
        url: `api/webUser/register`,
        data: data,
        method: 'post'
    })
}

export function getContributionListApi(data) {
    return axios({
        url: `api/tabDynamic/getContributionList${getParameter(data)}`,
        method: 'get'
    })
}

export function getContributionInfoApi(data) {
    return axios({
        url: `api/tabDynamic/getContributionInfo${getParameter(data)}`,
        method: 'get'
    })
}

export function saveContributionArticleApi(data) {
    return axios({
        url: `api/tabDynamic/saveContributionArticle`,
        data: data,
        method: 'post'
    })
}

export function getAiNewsListApi(data) {
    return axios({
        url: `api/tabDynamic/getAiNewsList${getParameter(data)}`,
        method: 'get'
    })
}

export function getAiNewsInfoApi(data) {
    return axios({
        url: `api/tabDynamic/getAiNewsInfo${getParameter(data)}`,
        method: 'get'
    })
}

export function getForumPostListApi(data) {
    return axios({
        url: `api/tabDynamic/getForumPostList${getParameter(data)}`,
        method: 'get'
    })
}

export function saveForumPostApi(data) {
    return axios({
        url: `api/tabDynamic/saveForumPost`,
        data: data,
        method: 'post'
    })
}

export function deleteForumPostApi(data) {
    return axios({
        url: `api/tabDynamic/deleteForumPost${getParameter(data)}`,
        method: 'post'
    })
}

export function toggleForumLikeApi(data) {
    return axios({
        url: `api/tabDynamic/toggleForumLike${getParameter(data)}`,
        method: 'post'
    })
}

export function getForumCommentListApi(data) {
    return axios({
        url: `api/tabDynamic/getForumCommentList${getParameter(data)}`,
        method: 'get'
    })
}

export function saveForumCommentApi(data) {
    return axios({
        url: `api/tabDynamic/saveForumComment`,
        data: data,
        method: 'post'
    })
}

export function deleteForumCommentApi(data) {
    return axios({
        url: `api/tabDynamic/deleteForumComment${getParameter(data)}`,
        method: 'post'
    })
}

export function getCampusProposalListApi(data) {
    return axios({
        url: `api/tabDynamic/getCampusProposalList${getParameter(data)}`,
        method: 'get'
    })
}

export function getCampusProposalInfoApi(data) {
    return axios({
        url: `api/tabDynamic/getCampusProposalInfo${getParameter(data)}`,
        method: 'get'
    })
}

export function saveCampusProposalApi(data) {
    return axios({
        url: `api/tabDynamic/saveCampusProposal`,
        data: data,
        method: 'post'
    })
}

export function getJobPositionListApi(data) {
    return axios({
        url: `api/tabDynamic/getJobPositionList${getParameter(data)}`,
        method: 'get'
    })
}

export function saveJobResumeApi(data) {
    return axios({
        url: `api/tabDynamic/saveJobResume`,
        data: data,
        method: 'post'
    })
}

export function uploadResumeFileApi(file) {
    var formData = new FormData()
    formData.append('file', file)
    return axios({
        url: 'web/file/upload',
        data: formData,
        method: 'post'
    })
}


// WEBPACK FOOTER //
// ./src/api/index.js